import { Card, Col, Modal, Row } from 'antd';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { errorCatch, JSXMap, POST, QueryDetail, QueryOrder, QueryParam, updateInArray } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PopolnenieScheta from '../../forms/PopolnenieScheta';
import VivodSoScheta from '../../forms/VivodSoScheta';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import User from '../../../common/User';
import OstatkiPoSchetu from '../../forms/OstatkiPoSchetu';
import FederationadministratorEventsOrdersAll from '../FederationadministratorEventsOrdersAll';
import PageLayout from '../../components/PageLayout';
import FilterFieldLabel from '../../components/FilterFieldLabel';

var _ = require('lodash');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function FederationadministratorManagementAccounts(props) {
    const classes = useStyles();
    const { auth } = props;
    const dispatch = useDispatch();

    const filters = () => [
        {
            label: "Тип счета",
            name: "akkauntType",
            filterType: "group",
            queryFilter: [
                QueryDetail("model"),
                QueryOrder("code", "ASC"),
                // QueryParam("w-in-id", "2,9")
                QueryParam("w-neq-id", "7")
            ],
            display: (o) => o.opisanie,
            sort: true,
            filter: true,
            // filtered: [2],
        },
        {
            label: "Баланс счета",
            name: "ostatok",
            filterType: "range",
            func: ["min", "max"],
            sort: true,
            filter: true,
        },
        {
            label: "Номер счета",
            name: "nomerAkkaunta",
            sort: true,
            filter: true,
        },
        {
            label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
            name: "accountInfo.vladelets",
            // queryComparer:"swsim", // sim, wsim, swsim
            sort: true,
            filter: true,
        },
    ];

    const akkauntBalance = (akkaunt) => {
        if (!akkaunt) return 0;
        if (akkaunt.ostatok >= 0) {
            return (<div style={{ color: "rgb(63, 134, 0)" }}>
                + {Math.abs(Number(akkaunt.ostatok.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
            </div>)
        }
        if (akkaunt.ostatok < 0) {
            return (<div style={{ color: "red" }}>
                - {Math.abs(Number(akkaunt.ostatok.toFixed(2))).toLocaleString('ru', { minimumFractionDigits: 2 })} руб.
            </div>)
        }
        return 0
    }
    const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) =>
    (<div key={item.ID || idx} style={{ width: "100%" }}>
        <div className={classes.item}>
            <div style={{ flex: "1 1 auto" }}>
                {/* <User item={item?.polzovatel} /> */}
                <div>№{item?.nomerAkkaunta} </div>
                <div key={item.ID + "-" + idx} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                    {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                </div>
            </div>
            <div style={{ flex: "0 0 150px" }}>
                <div style={{ alignSelf: "flex-start", color: "#7c7c7c", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "400", fontSize: "11px" }}>
                    Баланс:
                </div>
                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 25px", fontWeight: "500", fontSize: "14px" }}>
                    {akkauntBalance(item)}
                </div>
            </div>
        </div>
    </div>)

    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <CollectionServer
                    auth={auth}
                    name={"Akkaunti"}
                    queryDetail={"collection"}
                    // source={"/api/fed/admin/akkaunti-polzovatelei"}
                    filters={filters}
                    size={"small"}
                    mode={"list"}
                    title="Счета"
                    render={render}
                    modelActions={(item) => {
                        return [
                            {
                                title: "Пополнение счета",
                                titles: {
                                    subheader: <div style={{ paddingBottom: "15px" }}>
                                        <div>№{item?.nomerAkkaunta} </div>
                                        <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                            {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                        </div>
                                    </div>
                                },
                                object: item,
                                form: PopolnenieScheta,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, '/api/fed/admin/popolneniescheta', { ...values },
                                        ({ data, account }) => {
                                            setCollection(updateInArray(collection, {
                                                ...item,
                                                ostatok: account.ostatok
                                            }));
                                            close();
                                        },
                                        (err) => errorCatch(err, unlock)
                                    );
                                },
                            },
                            {
                                title: "Списание со счета",
                                titles: {
                                    subheader: <div style={{ paddingBottom: "15px" }}>
                                        <div>№{item?.nomerAkkaunta} </div>
                                        <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                            {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                        </div>
                                    </div>
                                },
                                object: item,
                                form: VivodSoScheta,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    if (item && (item.ostatok - values.summa) < 0) {
                                        Modal.confirm({
                                            title: 'Отрицательный баланс!',
                                            icon: <ExclamationCircleOutlined />,
                                            okText: "Продолжить",
                                            cancelText: "Отмена",
                                            content: 'Выполняемая операция приведет к отрицательному остатку на счете! Продолжить?',
                                            onOk() {
                                                POST(auth, '/api/fed/admin/vivodsoscheta', { ...values },
                                                    ({ data, account }) => {
                                                        setCollection(updateInArray(collection, {
                                                            ...item,
                                                            ostatok: account.ostatok
                                                        }));
                                                        close();
                                                    },
                                                    (err) => errorCatch(err, unlock)
                                                );
                                            },
                                            onCancel() {
                                                unlock()
                                            },
                                        });
                                    } else {
                                        POST(auth, '/api/fed/admin/vivodsoscheta', { ...values },
                                            ({ data, account }) => {
                                                setCollection(updateInArray(collection, {
                                                    ...item,
                                                    ostatok: account.ostatok
                                                }));
                                                close();
                                            },
                                            (err) => errorCatch(err, unlock)
                                        );
                                    }
                                },
                            },
                            {
                                title: "Отчет по остаткам",
                                readonly: true,
                                noAntForm: true,
                                titles: {
                                    subheader: <div style={{ paddingBottom: "15px" }}>
                                        <div>№{item?.nomerAkkaunta} </div>
                                        <div key={item.ID} style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                                            {item?.akkauntType.opisanie}: {item?.accountInfo.vladelets}
                                        </div>
                                    </div>
                                },
                                modal: {
                                    width: "940px",
                                },
                                object: item,
                                location: "fedadmin",
                                form: OstatkiPoSchetu,
                                action: (values, unlock, close, { collection, setCollection }) => { },
                            },
                        ]
                    }}
                />
            </div>
        </PageLayout>

    );
}
